import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { FullViewProps } from '../types';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { getSource } from '../../_helpers';
import LoadablePlayer from './LoadablePlayer';
import { useVideoPlayerActionBiLogger } from '../hooks/useVideoPlayerActionBiLogger';

import { sanitizeHref } from '@wix/da-url';

import s from './Film.scss';

export const FilmFullView: React.FC<FullViewProps> = ({
  deviation,
  height,
  width,
}) => {
  const onPlaybackAction = useVideoPlayerActionBiLogger(deviation);
  const videoFile = getSource(
    DeviationMediaService.getMediaByType(deviation, 'video')
  );

  const previewFile = DeviationMediaService.getDeviationFile(
    deviation,
    'preview'
  );

  if (!videoFile) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="FilmFullView">
      {previewFile && (
        <link rel="preload" href={sanitizeHref(previewFile.src)} as="image" />
      )}
      <link
        rel="preload"
        href={sanitizeHref(videoFile.src)}
        as="video"
        crossOrigin="anonymous"
      />
      <div className={s['root']} style={{ width, height }}>
        <LoadablePlayer
          src={videoFile.src}
          poster={previewFile?.src}
          autoplay
          muted
          loop={videoFile.duration && videoFile.duration > 60 ? false : true}
          width={videoFile.width}
          height={videoFile.height}
          onPlaybackAction={onPlaybackAction}
        />
      </div>
    </ErrorBoundary>
  );
};
FilmFullView.displayName = 'FilmFullView';

export default FilmFullView;
